import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Profile } from '../core/models/profile.model';
import { User } from '../core/models/user.model';
import { catchError, of } from 'rxjs';
import { DropdownModel } from '../core';
@Injectable({ providedIn: 'root' })
export class UserService extends ApiService {
  private readonly avatarRequestHeaders = new HttpHeaders({
    'Cache-Control': 'no-cache, no-store, must-revalidate',
    Pragma: 'no-cache',
    Expires: '0',
  });

  constructor(http: HttpClient) {
    super(http, 'User');
  }

  updateProfile(user: Profile) {
    return this.http.post(`${this.route()}/ProfileUpdate`, user);
  }

  getProfile<T>() {
    return this.http.get<T>(`${this.route()}/GetProfile`);
  }

  /** Upload user avatar. Accepts jpg, jpeg, png, gif, webp. Returns updated user with avatarUrl. */
  uploadAvatar(file: File) {
    const formData = new FormData();
    formData.append('avatar', file);
    return this.http.post<User>(`${this.route()}/UploadAvatar`, formData);
  }

  /** Remove user avatar. Returns updated user, or 404 if user has no avatar. */
  removeAvatar() {
    return this.http.delete<User>(`${this.route()}/avatar`);
  }

  /** Get avatar image as blob for current user or a specific user id. */
  getAvatarBlob(userId?: string) {
    const baseUrl = userId ? `${this.route()}/avatar/${userId}` : `${this.route()}/avatar`;
    return this.http.get(baseUrl, { responseType: 'blob', headers: this.avatarRequestHeaders });
  }

  public suggestByName(term?: string) {
    const query = encodeURIComponent(term || '');
    if (!query) {
      return of([]);
    }
    const url = `${this.route()}/suggestByName/${query}`;
    return this.http.get<DropdownModel[]>(url).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 403) {
          return of([]);
        } else {
          throw error;
        }
      })
    );
  }

  public getCRMUsers() {
    return this.http.get<DropdownModel[]>(`${this.route()}/GetCRMUsers`).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 403) {
          return of([]);
        } else {
          throw error;
        }
      }),
    );
  }
}
